var map = {
	"./decidim/avatar-multiuser.png": 43766,
	"./decidim/brands/facebook.svg": 93152,
	"./decidim/brands/google.svg": 69881,
	"./decidim/brands/twitter-x.svg": 10066,
	"./decidim/cc-badge.png": 86632,
	"./decidim/decidim-logo.svg": 28724,
	"./decidim/default-avatar.svg": 19340,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 49400,
	"./decidim/icons.svg": 5735,
	"./decidim/pattern.png": 93000,
	"./decidim/placeholder-card-g.svg": 21709,
	"./decidim/placeholder-card-l.svg": 73702,
	"./decidim/placeholder.jpg": 22213,
	"./decidim/remixicon.symbol.svg": 42249,
	"./decidim/vendor/social-share-button/douban.svg": 72552,
	"./decidim/vendor/social-share-button/email.svg": 76101,
	"./decidim/vendor/social-share-button/facebook.svg": 66011,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 90645,
	"./decidim/vendor/social-share-button/hacker_news.svg": 30837,
	"./decidim/vendor/social-share-button/linkedin.svg": 97437,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 6382,
	"./decidim/vendor/social-share-button/pinterest.svg": 8507,
	"./decidim/vendor/social-share-button/reddit.svg": 58447,
	"./decidim/vendor/social-share-button/telegram.svg": 18658,
	"./decidim/vendor/social-share-button/tumblr.svg": 69345,
	"./decidim/vendor/social-share-button/twitter.svg": 60404,
	"./decidim/vendor/social-share-button/vkontakte.svg": 85386,
	"./decidim/vendor/social-share-button/wechat.svg": 44149,
	"./decidim/vendor/social-share-button/whatsapp.svg": 39301,
	"./decidim/vendor/social-share-button/x.svg": 76677,
	"./decidim/vendor/social-share-button/xing.svg": 83803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65515;